module.exports = __webpack_public_path__ + "static/media/10.fe41db43.svg";